import { useTranslations } from 'next-intl';
import Image from 'next/image';
import rewardIcon from '@/public/assets/icons/gamification/reward-icon.svg';
import { cn } from '@/utils/cn';
import { GmBadge } from '../GmBadge';

interface Props {
  className?: string;
}

// Shown on a reward card that has something to claim, without telling how much.
export const GmRewardGiftBadge = ({ className }: Props) => {
  const t = useTranslations('gamification');

  return (
    <GmBadge variant="desktop" className={cn('size-7 p-1', className)}>
      <Image src={rewardIcon} alt={t('reward-available')} width={18} height={18} className="size-4.5" />
    </GmBadge>
  );
};
